// utils/ordenarPedidos.js
// ─────────────────────────────────────────────────────────────────
// Criterio canónico de ordenamiento de pedidos — usado en toda la app.
//
// Orden:
//   1. Prioridad        Alta=0  Media=1  Baja=2   (ascendente)
//   2. Fecha compromiso más próxima primero        (ascendente, null al final)
//   3. Total de piezas  mayor primero              (descendente)
//
// Mantener sincronizado con consumers.py (_orden_pedidos)
// ─────────────────────────────────────────────────────────────────

const PESO_PRIORIDAD = { Alta: 0, Media: 1, Baja: 2 }

/**
 * Comparador para Array.prototype.sort()
 * @param {object} a
 * @param {object} b
 * @returns {number}
 */
export function compararPedidos(a, b) {
  // 1. Prioridad
  const pa = PESO_PRIORIDAD[a.prioridad] ?? 1   // sin prioridad → Media
  const pb = PESO_PRIORIDAD[b.prioridad] ?? 1
  if (pa !== pb) return pa - pb

  // 2. Fecha compromiso (null al final)
  const fa = a.fecha_compromiso ? new Date(a.fecha_compromiso).getTime() : Infinity
  const fb = b.fecha_compromiso ? new Date(b.fecha_compromiso).getTime() : Infinity
  if (fa !== fb) return fa - fb

  // 3. Total de piezas (mayor primero)
  const ta = Number(a.total_articulos ?? a.total_piezas ?? 0)
  const tb = Number(b.total_articulos ?? b.total_piezas ?? 0)
  return tb - ta
}

/**
 * Devuelve una copia ordenada del array de pedidos.
 * @param {object[]} pedidos
 * @returns {object[]}
 */
export function ordenarPedidos(pedidos) {
  return [...pedidos].sort(compararPedidos)
}